import {Component} from "@angular/core";
import {
    AbstractSearchControlComponent,
    registerSearchControl
} from "../../../entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-date-search-control",
    templateUrl: "./date-search-control.component.html",
    providers: [
        registerSearchControl(DateSearchControlComponent)
    ]
})
export class DateSearchControlComponent extends AbstractSearchControlComponent {
    constructor() {
        super();
    }
}
